import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
} from '@mui/material';
import {
  Home,
  Groups,
  QrCodeScanner,
  Menu as MenuIcon,
  Assessment,
} from '@mui/icons-material';
import { GRADIENTS, RADIUS_LIBRARIAN as RADIUS } from '../theme/tokens';

const TABS = [
  { label: 'Home', icon: <Home />, path: '/librarian' },
  { label: 'Sessions', icon: <Groups />, path: '/librarian/sessions' },
  { label: 'Scanner', icon: <QrCodeScanner />, path: '/librarian/scanner' },
  { label: 'Analytics', icon: <Assessment />, path: '/librarian/analytics' },
  { label: 'Profile', icon: <MenuIcon />, path: '/librarian/manage' },
];

const MANAGE_SUBPATHS = [
  '/librarian/manage',
  '/librarian/students',
  '/librarian/bookings',
  '/librarian/library-details',
  '/librarian/settings',
  '/librarian/plans',
  '/librarian/wallet',
  '/librarian/website',
];

function getActiveIndex(pathname) {
  if (pathname === '/librarian' || pathname === '/librarian/') return 0;
  if (pathname.startsWith('/librarian/sessions')) return 1;
  if (pathname.startsWith('/librarian/scanner')) return 2;
  if (pathname.startsWith('/librarian/analytics')) return 3;
  if (MANAGE_SUBPATHS.some((p) => pathname.startsWith(p))) return 4;
  return 0;
}

function LibrarianBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const value = getActiveIndex(location.pathname);

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        borderTopLeftRadius: RADIUS.xl,
        borderTopRightRadius: RADIUS.xl,
        overflow: 'hidden',
        background: GRADIENTS.brand,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <BottomNavigation
        value={value}
        onChange={(_, newValue) => navigate(TABS[newValue].path)}
        showLabels
        sx={{
          background: 'transparent',
          height: 70,
          '& .MuiBottomNavigationAction-root': {
            color: 'rgba(255, 255, 255, 0.6)',
            minWidth: 'auto',
            padding: '6px 12px',
            transition: 'all 0.3s ease',
            '&:hover': {
              color: 'rgba(255, 255, 255, 0.9)',
            },
            '&.Mui-selected': {
              color: 'white',
              fontSize: '0.75rem',
              paddingTop: '6px',
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.75rem',
                fontWeight: 700,
              },
              '& .MuiSvgIcon-root': {
                transform: 'scale(1.2)',
                filter: 'drop-shadow(0 2px 8px rgba(255, 255, 255, 0.3))',
              },
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.7rem',
            fontWeight: 600,
            marginTop: '4px',
          },
        }}
      >
        {TABS.map((tab) => (
          <BottomNavigationAction key={tab.label} label={tab.label} icon={tab.icon} />
        ))}
      </BottomNavigation>
    </Paper>
  );
}

export default LibrarianBottomNav;
